import ChannelService from './channel.service'
import JiYunService from './jiyun.service'
import CarrierService from './carrier.service'
import OrderService from './order.service'
import ShaanxiService from './shaanxi.service'
import CommonService from './common.service'
import GoodsService from './goods.service'
import AppService from './app.service'
import FlowManagement from './flowManagement.service'
import AnalyseService from './analyse.service'

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $service: {
        get() {
          return {
            ChannelService: ChannelService.init(this),
            JiYunService: JiYunService.init(this),
            CarrierService: CarrierService.init(this),
            OrderService: OrderService.init(this),
            ShaanxiService: ShaanxiService.init(this),
            CommonService: CommonService.init(this),
            GoodsService: GoodsService.init(this),
            AppService: AppService.init(this),
            FlowManagement: FlowManagement.init(this),
            AnalyseService: AnalyseService.init(this)
          }
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/index.js